<template>
<div class="vx-col w-full mb-base" id="account-info-col-1">
    <div class="vx-col flex-1">

        <ul>
            <li v-for="(item, index) in reportItems" :key="index" class="mt-5 flex items-center justify-between">
                <!-- <div class="vx-row"> -->
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-3" >
                        <vs-checkbox v-model="selected[index]" :vs-value="item.value" class="ml-2">{{ item.reportName }}</vs-checkbox>
                    </div>
                    <div v-show="index === 0 ? true: false" class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full " >
                            <span  class="text-sm">Month</span><span style="color:red">*</span>
                                <v-select v-validate="'required'"  name="monthName" v-model="monthName" label="monthName"  :options="getActiveMonths" placeholder="Please Select"/>
                            <span class="text-danger">{{ errors.first('step-1.monthName') }}</span>
                    </div>
                    <div v-show="index === 1 ? true: false" class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full " >
                        <span  class="text-sm">Year</span><span style="color:red">*</span>
                            <v-select v-validate="'required'"  name="yearToDate" v-model="yearScope"   :options="generateArrayOfYears" placeholder="Please Select"/>
                        <span class="text-danger">{{ errors.first('step-1.yearToDate') }}</span>
                    </div>
                    <!-- </div> -->
                    <div v-show="selected[index] === 'PayrollGrossPay-History' ? true: false" class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2  w-full " >
                        <span  class="text-sm">Employee Code</span><span style="color:red">*</span>
                        <vs-input v-validate="'required'"  name="employeeCode" v-model="employeeCode"   />
                    </div>

                    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full" />
                    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full" />
                    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full" />
                    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full" />
                <!-- </div> -->
                <!-- <span>{{selected }}</span> -->
            </li>
        </ul>

    </div>
    <div class="flex justify-between flex-wrap mt-5">
        <span/>
        <vs-button @click="onSetPasswordToOpen()" color="success" type="filled" icon-pack="feather" icon="icon-download">Generate Reports</vs-button>
    </div>

    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import VueApexCharts from 'vue-apexcharts'
import analyticsData from '../../ui-elements/card/analyticsData.js'

import axios from '@/axios.js'
import Swal from 'sweetalert2'

export default {
    props: {
        createPayroll: {
            type: Array,
            required: false
        },

    },
    data() {
        return {
            counter         :0,
            percentage      :[0],
            creditDate: moment().format('DD MMM yyyy'),
            payOutDate: [],
            monthName: null,
            yearScope: new Date().getFullYear(),
            employeeCode: null,

            analyticsData,

            reportItems: [
                { value: 'PayrollSSS-Monthly', reportName: 'SSS Monthly Reports'},
                { value: 'PayrollPhilhealth-Monthly', reportName: 'Philheath Monthly Reports'},
                { value: 'PayrollPagibig-Monthly', reportName: 'Pagibig Monthly Reports'},
                { value: 'PayrollLoanPayments-Monthly', reportName: 'Loan Payments'},
                { value: 'PayrollDeductions-Monthly', reportName: 'Pagibig MP2'},
                { value: 'PayrollGrossPay-History', reportName: 'GrossPay History'},
                { value: 'PayrollWithholdingTax-Monthly', reportName: 'Total Compensation - with WHTax'},
                { value: 'PayrollWithholdingTaxZero-Monthly', reportName: 'Total Compensation - Zero Whtax'}

            ],
            // selected:[ "PayrollEarnings", "PayrollDeductions", "PayrollLoans", "PayrollBankRemittance", "PayrollBankAdvise", "PayrollRegister", "PayrollRegisterProjectStaff", "PayrollProoflist"],
            selected:[],
            passwordToOpen:''


        }
    },
    created() {
      this.$store.dispatch('payroll/getAllCreatePayroll')
            .then(() => {
                this.$vs.loading.close()
            })
            .catch((err) => {
                this.$vs.loading.close()
                console.log(err)
            })
    },
    computed: {
        getAllCreatePayroll() {
            return this.$store.state.payroll.getAllCreatePayroll
        },
        getActiveMonths() {
            let createPayroll = this.getAllCreatePayroll
            const unique = [...new Set(createPayroll.map(item => item.monthName))]
            console.log(unique)
            return unique

        },
        getAllPayOutDate() {
            let p = this.getAllCreatePayroll
            let payOutDate = []
            p.forEach(d => {
                console.log(d)
                payOutDate.push(Object.assign(d, { payOutDate: moment(d.payOutDate).format('YYYY-MM-DD')}))
            })
            return payOutDate
        },
        getAllLogHours() {
            return this.$store.state.payroll.getAllLogHours
        },
        generateArrayOfYears() {
            let createPayroll = this.getAllCreatePayroll
            const years = [...new Set(createPayroll.map(item => item.calendarYear))]
            return years
        },
        tenantName() {
            return (id) => this.$store.getters['tenants/tenantName'](id)
        },
        getUserIdByEmployeeCode() {
            return (employeeCode) => this.$store.getters['hrms/getEmployeeByEmployeeCode'](employeeCode)
        }
    },
    methods: {
        onGenerateReports() {


            this.percentageReport = [0]
            this.counterReports = 0
            let tenant = this.tenantName(this.$store.state.AppActiveUser.tenantsId)
            var logoPath = ''

            if(tenant.photoId != null) {
                 this.$store.dispatch('getFile', tenant.photoId) //Get filePath of Company Logo
                    .then((response) => {
                        logoPath = response.data.path

                })
            }

            var uid = this.employeeCode !== null ? this.getUserIdByEmployeeCode(this.employeeCode).id : this.$store.state.AppActiveUser.uid
            console.log(this.employeeCode)
            console.log(uid)
            //Export Report in ZIP File
            const data = {
                serverName: tenant.secretKey,
                dbName: tenant.apiKey,
                userName: '',
                password: '',
                companyCode: tenant.code,
                companyName: tenant.name,
                address: tenant.address,
                photoURL: logoPath,
                createPayrollId: 0,//this.createPayroll.createPayrollId,
                printedBy: this.$store.state.AppActiveUser.uid,
                reportName:this.selected,//['PayrollSummary', 'PayrollEarnings'],
                payOutDate: '', //moment(this.createPayroll.payOutDate).format('YYYYMMDD'),
                creditDate: this.creditDate,
                passwordToOpen: this.passwordToOpen,
                monthName: this.monthName,
                yearScope: this.yearScope,
                reportType: 'MONTHLY',
                userId: [uid]
            }

            // this.$vs.loading()
            this.$store.dispatch('payroll/GenerateReports', data)
            .then(() => {
                var zipFileName = tenant.code + '_MONTHLY.zip'
                var pDate = ''
                // var zipFileName = tenant.code + '_' + moment(this.createPayroll.payOutDate).format('YYYYMMDD') + '.zip'
                // var pDate = moment(this.createPayroll.payOutDate).format('YYYYMMDD')
                axios.get(`/api/reports/OtherReports?dbName=${tenant.code}&fileName=${zipFileName}&reportType=MONTHLY&monthName=${this.monthName}&yearScope=${this.yearScope}`
                ,{ reportProgress: true, responseType: 'blob' })
                    .then((response) => {
                            this.$vs.loading.close()
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', zipFileName);
                            document.body.appendChild(link);
                            link.click();

                            Swal.fire({ title: 'Done', html: 'Reports Generated', icon:'success', timer: 2000, timerProgressBar: true,})
                    })
                    .catch((error) => {
                        this.$alert(error.message, 'Error', 'error')
                    })
            })
        },
        onSetPasswordToOpen() {
            Swal.fire({
                    title: 'Set Password',
                    input: 'password',
                    inputLabel: 'Password',
                    inputPlaceholder: 'Max of 10 characters',
                    inputAttributes: {
                    maxlength: 10,
                    autocapitalize: 'off',
                    autocorrect: 'off'
                }
            })
            .then((t) => {
                // console.log(t.value)
                this.passwordToOpen = t.value
                if(t.value == '') {
                    this.$alert("This is an important file and must have a password ", "Password Required", "info")
                } else {
                    this.onOpenWaitingDialog()
                }
            })

        },
        onOpenWaitingDialog() {
            Swal.fire({
                title: 'Generating Reports!',
                html: 'Please wait while report is generating...',
                timer: 2000,
                showConfirmButton: false,
                didOpen: () => {
                    this.onGenerateReports()
                },
                }).then((result) => {
                /* Read more about handling dismissals below */
                if (result.dismiss === Swal.DismissReason.timer) {
                    // console.log('I was closed by the timer')
                }
            })
        }
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        VueApexCharts,
        Swal,
    }
}
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>
